import apiClient from './apiClient';

export interface SendVideoResponse {
  success: boolean;
  message: string;
  data?: {
    messageId: number;
    mediaId: number;
  };
}

export const videoService = {
  /**
   * Enviar vídeo para cliente
   */
  async sendVideoToClient(conversationId: number, video: File, messageText?: string): Promise<SendVideoResponse> {
    const formData = new FormData();
    formData.append('video', video);
    formData.append('conversationId', conversationId.toString());
    if (messageText) {
      formData.append('messageText', messageText);
    }

    const response = await apiClient.post('/videos/send-video', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },

  /**
   * Upload de vídeo para armazenamento
   */
  async uploadVideo(conversationId: number, video: File): Promise<{ videoUrl: string }> {
    const formData = new FormData();
    formData.append('video', video);
    formData.append('conversationId', conversationId.toString());

    const response = await apiClient.post('/videos/upload-video', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  }
};
